import { Module } from '@nestjs/common';
import { QaQcOperationsService } from './qa-qc-operations.service';
import { QaQcOperationsController } from './qa-qc-operations.controller';
import { TypeOrmModule } from '@nestjs/typeorm';
import { QaQcOperationsRepository } from './qa-qc-operations.repository';
import { QaQcDataAdapter } from './dto/qa-qc-data.adapter';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LabellingService } from '../operations-track/labelling/labelling.service';
import { LabellingController } from '../operations-track/labelling/labelling.controller';
import { ProductInspectionController } from './product-inspection/product-inspection.controller';
import { ProductInspectionService } from './product-inspection/product-inspection.service';
import { LabellingAdapter } from '../operations-track/labelling/dto/labelling.adapter';
import { Labelling } from '../operations-track/labelling/entities/labelling.entity';
import { ProductInspectionRepository } from './product-inspection.repository';
import { ProductInspecAdapter } from './dto/product-inspection.adapter';
import { ProductInspection } from './product-inspection.entity';
import { LabellingSamples } from '../operations-track/labelling/entities/labelling-samples.entity';
import { ProductInspectionSamples } from './product-inspection-samples.entity';
import { ProductInspectionSamplesRepository } from './product-inspection-samples.repository';
import { MetalDetectionController } from './metal-detection/metal-detection.controller';
import { MetalDetectionService } from './metal-detection/metal-detection.service';
import { MetalDetectionRepository } from './metal-detection/metal-detection.repository';
import { LogsService } from '@gtpl/shared-services/user-logs';
@Module({
  imports: [
    TypeOrmModule.forFeature([QaQcOperationsRepository,Labelling, ProductInspectionRepository, ProductInspection,LabellingSamples,ProductInspectionSamples,ProductInspectionSamplesRepository, MetalDetectionRepository])
  ],
  providers: [QaQcOperationsService, QaQcDataAdapter, ApplicationExceptionHandler, LabellingService,LabellingAdapter, ProductInspectionService, ProductInspecAdapter, MetalDetectionService,LogsService],
  controllers: [QaQcOperationsController, LabellingController, ProductInspectionController, MetalDetectionController],
  exports: [QaQcOperationsService,LabellingService, ProductInspectionService]


})
export class QaQcOperationsModule {}
